<template>
  <div class="group relative inline-flex flex-col items-center">
    <span v-html="icon"></span>
    <!-- <svg class="w-5 h-5" fill="none" stroke="#a0aec0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg> -->
    <div
      :class="[orientation == 'top' ? '-mb-6' : 'mb-6', right ? 'right-0' : '']"
      class="absolute bottom-0 z-20 flex hidden flex-col items-center group-hover:flex"
    >
      <span
        class="whitespace-no-wrap relative z-10 rounded bg-ontick-green-500 p-2 text-xs font-medium leading-none text-gray-800 shadow-lg"
        >{{ value }}</span
      >
      <div
        :class="[orientation == 'top' ? '-mt-8 ' : '-mt-2']"
        :style="right ? 'margin-left:80%' : 'margin-left:0px'"
        class="h-3 w-3 rotate-45 rounded bg-ontick-green-500"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "form-tooltip",

  props: {
    value: {
      type: String,
      required: true,
    },

    icon: {
      type: String,
      required: false,
      default: `<svg class="w-4 h-4 help" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#a0aec0">
      <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
    </svg>`,
    },

    orientation: {
      type: String,
      default: "bottom",
    },

    right: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.rotate-45 {
  --transform-rotate: 45deg;
  transform: rotate(45deg);
}
.group:hover .group-hover\:flex {
  display: flex;
}
.help {
  fill: #a0aec0;
  &:hover {
    fill: #19d684;
  }
}
</style>
